import {post} from './AXIOS';
import {ASK_POLICY_AI, ASK_POLICY_AI_STREAM} from './CONSTANTS';


export const askPolicyAI = async (policy_filename, question) => {
  try {
    return await post(ASK_POLICY_AI, {
        policy_filename,
        question
      }, {"headers": {"Content-Type": "application/json"}}
    );
  } catch (error) {
    console.error('Error asking policy AI:', error.response ? error.response : error);
    throw error;
  }
};


export const askPolicyAIStream = async (filename, question, {signal}) => {
  const response = await fetch(ASK_POLICY_AI_STREAM, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      policy_filename: filename,
      question,
    }),
    signal,
  });

  if (!response.ok) {
    throw new Error('Failed to fetch streamed response');
  }

  return response.body; // return the ReadableStream directly
};

